import makeUseCellFilterAction, {
  UseCellFilterActionProps,
} from "ds/components/Table/helpers/makeUseCellFilterAction";
import { INTENT_PROJECTS_SUGGESTIONS_DICTIONARY } from "shared/IntentProject/useSearchIntentProjectsSuggestions/constants";

const useCellFilterAction = (props: UseCellFilterActionProps) => {
  return makeUseCellFilterAction({
    searchSuggestionsDictionary: INTENT_PROJECTS_SUGGESTIONS_DICTIONARY,
  })(props);
};

export default useCellFilterAction;
